'use strict';

var App = require('app');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var ValueModel = require('models/values').Model;
var IsTargetValue = require('models/rule').IsTargetValue;

var RemoteValueView = Marionette.ItemView.extend({
    template: require('components/devices/remote_values/templates/remote_value'),

    ui: {
        toggleSource: '#js-source-offline',
        toggleTarget: '#js-toggle-target-offline',
        selectDevice: 'select#js-device-select',
        deleteTargetValue: '.js-delete-target-offline-value',
        valueInputs: 'select.js-fv-sel-1, .js-fv-tb-1, .js-fv-tb-2, .js-fv-tb-3',
    },

    events: {
        'change @ui.selectDevice': 'switchDevice',
        'change select.js-value-select': 'switchValue',
        'change @ui.valueInputs': 'setValue',
        'click @ui.deleteTargetValue': 'deleteTargetValue',
        'click @ui.toggleSource': 'setSourceFallback',
        'click @ui.toggleTarget': 'setTargetFallback',
    },

    initialize: function (options) {
        this.targetValue = options.targetValue;
        this.values = options.values;
        this.remoteState = options.remoteState;
        this.targetFallbackEnabled = this.remoteState.get('fallbackValues').getTargetValues().data.length > 0;
        this.sourceFallbackEnabled = this.remoteState.get('fallbackValues').getValue('offline') != undefined;
        this.isFirstRender = true;
    },

    serializeData: function () {
        var deviceCategory = this.options.device.get('category');

        var displayData = this.remoteState.getDisplayState(this.values);
        this.targetOfflineValues = [];

        if (displayData.values) {
            displayData.values.sort(function (e1, e2) {
                // case insensitive comparison -> convert to upper case
                var name1 = i18n.DATAPOINT(deviceCategory, e1.get('name')).toUpperCase();
                var name2 = i18n.DATAPOINT(deviceCategory, e2.get('name')).toUpperCase();

                return name1 > name2 ? 1 : name2 > name1 ? -1 : 0;
            });
        }

        _.each(
            displayData.allValues,
            function (value, key) {
                if (IsTargetValue(key)) {
                    this.targetOfflineValues.push([
                        { ID: value.cid, referenceID: key },
                        {
                            name: value.type + '_' + value.nr,
                            object: displayData.rawValues, // a target-fallback values already saved for this device
                            key: key, // key referencing the above value
                        },
                    ]);
                }
            },
            this
        );

        // append placeholder for new value
        this.targetOfflineValues.push([
            { ID: undefined, referenceID: 'dummy' },
            { name: 'd_d', object: displayData.rawValues, key: 'dummy' },
        ]);

        if (this.targetFallbackEnabled) {
            displayData.targetOfflineConfiguration = {
                rows: this.targetOfflineValues,
                columnConfiguration: [
                    {
                        width: 8,
                        heading: i18n.TR('Datenpunkt'),
                        inputType: 'select',
                        values: this.remoteState.get('fallbackValues').formats.models,
                        category: this.options.device.get('category'),
                    },
                    {
                        width: 3,
                        heading: i18n.TR('Wert'),
                        inputType: 'value',
                    },
                ],

                deleteButtonIDPrefix: 'target-offline',
                deleteButtonClass: 'js-delete-target-offline-value',

                addButtonID: 'js-add-target-offline-value',
            };
        }

        return $.extend(
            true,
            {
                deviceCategory: deviceCategory,
                valueName: this.targetValue.attributes.type + '_' + this.targetValue.attributes.nr,
                targetFallbackEnabled: this.targetFallbackEnabled,
                sourceFallbackEnabled: this.sourceFallbackEnabled || this.remoteState.offlineDetectionEnabled(),
                showFallback:
                    this.remoteState.get('sourceDeviceID') &&
                    this.options.device.id &&
                    this.remoteState.get('sourceDeviceID') != this.options.device.id,
                // show info, if there is at least one fallback value defined.
                showFallbackInfo:
                    this.targetFallbackEnabled &&
                    _.some(this.targetOfflineValues, function (value) {
                        return value[0].referenceID != 'dummy';
                    }),
            },
            displayData
        );
    },

    onRender: function () {
        if (!this.isFirstRender) {
            this.triggerMethod('remote:value:validity');
        }
        this.isFirstRender = false;

        Misc.initSelectPicker();
        Misc.initDevicePicker();
    },

    onShow: function () {
        this.triggerMethod('remote:value:validity');
        if (this.remoteState.get('sourceDeviceID') > 0) {
            this.loadValues();
        }
    },

    switchValue: function (e) {
        var elementID = e.currentTarget.id;
        if (elementID == 'js-value-select') {
            this.remoteState.setSourceValueID(parseInt(e.currentTarget.value));
        } else {
            this.remoteState.get('fallbackValues').changeFormat(elementID, e.currentTarget.value);
            this.render();
            return;
        }
        this.remoteState.initializeValues();
        this.remoteState.set('unit', this.targetValue.get('unit'));
        this.remoteState.set('stepSize', this.stepSize);
        this.render();
    },

    setSourceFallback: function (e) {
        this.sourceFallbackEnabled = this.ui.toggleSource.is(':checked');
        this.remoteState.initializeValues(this.sourceFallbackEnabled);
        this.render();
    },

    setTargetFallback: function () {
        this.targetFallbackEnabled = this.ui.toggleTarget.is(':checked');
        this.remoteState.get('fallbackValues').invalidateTarget();
        this.render();
    },

    setValue: function (e) {
        var type = e.currentTarget.attributes['data-fvid'].nodeValue;
        var fbv = this.remoteState.get('fallbackValues');
        fbv.setFormatted(type, e.currentTarget.value);

        // both values may have changed ->reflect state in the ui
        if (['offline', 'online'].includes(type) && fbv.getValue(type).type === 'MBC') {
            $('.selectpicker.js-fv-sel-1[data-fvid="js-fallback-value-offline"]').selectpicker(
                'val',
                fbv.getFormatted(type)
            );
        } else {
            if (e.currentTarget.tagName != 'SELECT') {
                e.currentTarget.value = fbv.getFormatted(type);
            }
        }
        this.triggerMethod('remote:value:validity');
    },

    deleteTargetValue: function (e) {
        var rowIdx = e.currentTarget.id.split('-')[2];
        this.remoteState.get('fallbackValues').remove(this.targetOfflineValues[rowIdx][1].key);
        this.render();
    },

    isValid: function () {
        if (
            this.remoteState.get('sourceValueID') === undefined ||
            this.remoteState.get('sourceDeviceID') === undefined
        ) {
            return false;
        }

        var fbv = this.remoteState.get('fallbackValues');
        var onlineValue = fbv.getValue('online');
        if (
            this.sourceFallbackEnabled &&
            (!this.remoteState.hasOfflineValue() || (onlineValue && isNaN(parseInt(onlineValue.getRaw()))))
        ) {
            return false;
        }

        if (this.remoteState.offlineDetectionEnabled() && isNaN(parseInt(onlineValue.getRaw()))) {
            return false;
        }

        if (this.targetFallbackEnabled) {
            return _.some(fbv.values, function (_v, key) {
                return IsTargetValue(key);
            });
        }

        return true;
    },

    switchDevice: function () {
        this.remoteState.setSourceDeviceID($(this.ui.selectDevice).val());
        // reset ui
        this.render();
        this.loadValues();
    },

    loadValues: function () {
        var deviceID = this.remoteState.get('sourceDeviceID');
        Decorator.disableElement($('.modal-content'));

        var self = this;
        var targetValue = this.targetValue.attributes;
        var valueRequest = App.request('device:values', deviceID);
        $.when(valueRequest).done(function (values) {
            Decorator.enableElement($('.modal-content'));
            if (values === undefined) {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    i18n.TR('Die Werte für das ausgewählte Gerät konnten nicht geladen werden.')
                );
                return;
            }

            // adding artificial value for offline/online detection
            if (targetValue.type != 'MBR' || (targetValue.nr != 100 && targetValue.nr != 101)) {
                values.add(
                    new ValueModel({
                        id: self.remoteState.offlineDetectionID,
                        name: '[' + i18n.TR('Statuserkennung') + ']',
                    })
                );
            }
            self.valuesLoaded(values);
        });
    },

    valuesLoaded: function (values) {
        // initialisation with rule
        var sourceValueID = this.remoteState.get('sourceValueID');
        if (!sourceValueID && this.remoteState.isValid()) {
            this.remoteState.setSourceValueIDFromRule(values);
        } else if (sourceValueID && this.values && !this.remoteState.offlineDetectionEnabled()) {
            // new device supports previous value? get the value's id from the new values collection
            var oldValue = this.values.get(sourceValueID);
            if (oldValue) {
                var newValue = values.getByAddress(oldValue.get('nr'), oldValue.get('type'));
            }

            if (newValue) {
                this.remoteState.setSourceValueID(newValue.get('id'));
            } else {
                this.remoteState.invalidateSouceValueID();
            }
        }

        this.values = values;
        this.render();
    },

    getTransfer: function () {
        var rvt = this.options.rvt;
        if (!rvt.valid()) {
            rvt.set('device_id', this.options.device.id);
            rvt.set('id', this.targetValue.getAddress());
        }

        // initialize refresh rate based on target value update class
        rvt.set('refresh_rate', this.targetValue.get('update_time') * 60);

        var fbv = this.remoteState.get('fallbackValues');
        var address = this.values.get(this.remoteState.get('sourceValueID')).getAddress();
        var sourceDeviceID = this.remoteState.get('sourceDeviceID');
        if (this.sourceFallbackEnabled || this.remoteState.offlineDetectionEnabled()) {
            if (this.remoteState.offlineDetectionEnabled()) {
                rvt.setRuleOfflineOnlineValue(
                    sourceDeviceID,
                    fbv.getValue('offline').rawValue,
                    fbv.getValue('online').rawValue
                );
            } else {
                rvt.setRuleOfflineFallbackValue(sourceDeviceID, address, fbv.getValue('offline').rawValue);
            }
        } else {
            // create rule-collection with one default rule
            rvt.setRuleSimpleTransfer(address, [sourceDeviceID]);
        }

        if (this.options.saveCallback) {
            this.options.saveCallback();
        }
        return rvt;
    },

    getTargetFallbackValues: function (currentFallbackValues) {
        var updatedFallbackValues = this.remoteState.get('fallbackValues').getTargetValues();

        if (currentFallbackValues.disablingReason != '') {
            // fallback values not supported
            updatedFallbackValues.changed = false;
        } else {
            var currentConfigRegisters = (currentFallbackValues.config || { registers: [0, 0, 0, 1] }).registers.slice(
                3
            );

            // HINT: very simple "change" detection
            // - any fallbackb value configuration (current or update)? -> change
            // - invalid current fallback values?                       -> change
            updatedFallbackValues.changed =
                updatedFallbackValues.data.length != 0 ||
                currentConfigRegisters.filter(function (e) {
                    return e.value != 0;
                }).length > 0;
        }

        return updatedFallbackValues;
    },
});

module.exports = RemoteValueView;
